import AppLayout from "../components/layout/AppLayout";
import WorkflowStatsComponent from "../components/workflow/WorkflowStatsComponent";

export default function Workflow() {
  return (
    <AppLayout>
      <WorkflowStatsComponent />
    </AppLayout>
  );
}
